import React, { useState, useRef, useEffect } from "react";
import { useIsMobile } from "../context/MobileContext";
import { CircularProgress } from "@mui/material";

type CopyDivProps = {
  payload: string;
  isMobile?: boolean;
};

const CopyDiv: React.FC<CopyDivProps> = ({ payload }) => {
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const isMobile = useIsMobile()

  // Copiar para clipboard
  const handleCopy = () => {
    navigator.clipboard.writeText(payload).then(() => {
      setCopied(true);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => setCopied(false), 1500); // volta ao texto original
    });
  };

  // Para manter a largura constante, medimos o texto mais longo
  const hiddenRef = useRef<HTMLDivElement>(null);

  return (
    <div
      style={{
        border: "2px solid #3a3a3a",
        backgroundColor: "#1b1b1b",
        borderRadius: "10px",
        padding: "15px",
        width: isMobile ? "70vw" : "400px",
        color: "#fff",
        margin: "0 auto",
        wordBreak:'break-all',
        fontSize: isMobile ? "14px" : "",
        cursor: payload?"pointer":'default',
        position: "relative",
        overflow: "hidden",
        height: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={handleCopy}
    >
      {/* Texto real */}
      <span
        style={{
        //   position: "absolute",
          transition: "opacity 0.3s",
          opacity: copied ? 0 : 1,
        }}
      >
        {payload}
      </span>

      {/* Texto "Código copiado!" */}
      <span
        style={{
          position: "absolute",
          transition: "opacity 0.3s",
          opacity: copied ? 1 : 0,
        }}
      >
        Código copiado!
      </span>

      {/* Texto escondido para manter o tamanho da div constante */}
        {!payload&&(<CircularProgress/>)}
      <span
        ref={hiddenRef}
        style={{ visibility: "hidden", position: "absolute" }}
      >
        {payload.length > "Código copiado!".length ? payload : "Código copiado!"}
      </span>
    </div>
  );
};

export default CopyDiv;
